module.exports = __webpack_public_path__ + "img/prize2.c8f406ca.png";